var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormatIconText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 399,
    height: 138,
    viewBox: "0 0 399 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(-728 -331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_FormatTextGray",
    "data-name": " FormatTextGray",
    width: 399,
    height: 12,
    rx: 6,
    transform: "translate(728 331)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "FromatTextBlue",
    width: 399,
    height: 12,
    rx: 6,
    transform: "translate(728 373)",
    fill: "#203250"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1527",
    "data-name": "Rectangle 1527",
    width: 399,
    height: 12,
    rx: 6,
    transform: "translate(728 415)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1529",
    "data-name": "Rectangle 1529",
    width: 399,
    height: 12,
    rx: 6,
    transform: "translate(728 457)",
    fill: "#bebebe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIconText);
export default __webpack_public_path__ + "static/media/Format_Icon_text.29356697.svg";
export { ForwardRef as ReactComponent };